import styled from 'styled-components';

const Text = styled.div`
  align-items: center;
  color: ${({ color }) => color || '#484C7A'};
  display: flex;
  font-family: 'Inter UI';
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  margin-right: 6px;
  opacity: 0.64;
  text-align: right;
`;

export default Text;
